<template>
  <div class="logo-container">
    <img alt="Sage & Thyme Nutrition logo" src="../assets/logo.png" class="logo">
  </div>
</template>

<script>
export default {
  name: 'AppLogo'
}
</script>

<style scoped>
.logo-container {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 20px;
}

.logo {
  max-width: 300px;
  height: auto;
}

@media (max-width: 768px) {
  .logo {
    max-width: 200px;
  }
}
</style>